import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePageMeta } from '../../hooks';

import styles from './PreviewLabel.scss';

export function PreviewLabel() {
  const { t } = useTranslation('common', { useSuspense: false });
  const { isPreview } = usePageMeta();

  if (!isPreview) return null;

  return (
    <div className={styles.fullWidthContainer}>
      <div className={styles.container}>
        <div className={styles.tab}>
          <span className={styles.label}>{t('page.preview', 'Preview')}</span>
        </div>
      </div>
    </div>
  );
}
